import React, { useId } from "react";
import { Link } from "react-router-dom";
import { API_BASE_URL } from "../../config";
import "../../styles/AdSelector.css";

// Picking an ad is required to book, and it used to be impossible without a
// mouse: each tile was a <div onClick> with no role, no tab stop and no
// keyboard handler. These are real radios in a named group, so arrow keys move
// between them and space selects — and a screen reader announces the group and
// which one is chosen.
//
// The empty case rendered nothing at all: a customer with no ads uploaded saw
// a blank space, and the form then refused to submit with "Choose an ad to
// run." There was no way from here to the page that uploads one.
//
// The `onUploadNewAd` / `newAdPreview` props are gone. Neither of the two call
// sites passed them, so that branch never rendered; the link below goes to the
// upload page that actually exists.

// Image.url is stored as "/static/uploads/<file>", which is a path on the API,
// not on the frontend. Rendered raw it resolved against the frontend's own
// origin and 404'd, so every tile in this picker was a broken image.
export function adImageUrl(ad) {
    const raw = ad.thumbnail_url || ad.url || ad.image_url || "";
    return raw.startsWith("/") ? `${API_BASE_URL}${raw}` : raw;
}

export default function AdSelector({ ads, selectedAdId, onSelect }) {
    const groupName = useId();

    if (!ads || ads.length === 0) {
        return (
            <p className="ads__empty">
                You have not uploaded any ads yet.{" "}
                <Link to="/upload">Upload one</Link> and it will appear here.
            </p>
        );
    }

    return (
        <fieldset className="ads">
            {ads.map((ad) => {
                const label = ad.name || `Ad #${ad.id}`;
                return (
                    <label className="ads__tile" key={ad.id}>
                        <input
                            className="ads__input"
                            type="radio"
                            name={groupName}
                            value={ad.id}
                            checked={ad.id === selectedAdId}
                            onChange={() => onSelect(ad.id)}
                        />
                        <span className="ads__mark" aria-hidden="true">✓</span>
                        <span className="ads__body">
                            <img
                                className="ads__img"
                                src={adImageUrl(ad)}
                                alt=""
                            />
                            <span className="ads__name">{label}</span>
                        </span>
                    </label>
                );
            })}
        </fieldset>
    );
}
